import { motion } from "framer-motion";
import type { ReactNode } from "react";

interface AnimatedProgressProps {
  /** Value between 0 and 100 */
  value: number;
  label?: string;
  className?: string;
}

export function AnimatedProgress({
  value,
  label,
  className = "",
}: AnimatedProgressProps): ReactNode {
  const clamped = Math.max(0, Math.min(100, value));

  return (
    <div
      className={`animated-progress ${className}`}
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      {label && <span className="animated-progress-label">{label}</span>}
      <div className="animated-progress-track">
        <motion.div
          className="animated-progress-fill"
          initial={{ width: 0 }}
          animate={{ width: `${clamped}%` }}
          transition={{ type: "spring", stiffness: 80, damping: 18 }}
        />
      </div>
      <span className="animated-progress-value">{Math.round(clamped)}%</span>
    </div>
  );
}
